// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"89":"Logout","94":"Login","162":"InvoiceArchive","274":"Home","543":"AddSubscription","553":"Contract","561":"Dashboard","691":"Invoices","810":"NotFound","848":"EditSubscription","855":"Subscriptions"}[chunkId] || chunkId) + ".bundle.js";
};